export default "__VITE_ASSET__B8hueE6P__"